import { Component, OnInit, EventEmitter, Output, HostListener, ChangeDetectorRef } from '@angular/core';
import { CfetBaseComponent,CFETILMEndpointsConstant, CfetService, LoaderService } from '../../../cfet-core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-dont-see-your-workplace-utf-form',
    templateUrl: './dont-see-your-workplace-utf-form.component.html',
    styleUrls: ['./dont-see-your-workplace-utf-form.component.scss'],
    standalone: false
})
export class DontSeeYourWorkplaceUtfFormComponent extends CfetBaseComponent implements OnInit {

  dontSeeYourWorkplaceFormGroup: UntypedFormGroup;
  nameValue: UntypedFormControl;
  address1Value: UntypedFormControl;
  address2Value: UntypedFormControl;
  cityValue: UntypedFormControl;
  stateValue: UntypedFormControl;
  zipCode: UntypedFormControl;
  stateValueOption: any;
  stateList: any[] = [];
  selectedName = '';
  selectedAddress1: any;
  selectedAddress2: any;
  selectedCity: any;
  selectedState: any;
  selectedZip: any;
  zipcodeError: boolean;
  values:any;
  isValidName = true;
  isValidAddress1: boolean;
  cityError: boolean;
   stateError: boolean;
  disabledSubmitButton = true;
  showEnterWorkplaceFormManuallySection = true;
  showEligibilityCompletion = false;
  displaySearchResult: boolean;
  noResultFound: boolean;
  fieldTabbed: boolean = false;
  addressList: any;
  checkState = '';
  checkstateAndZip = { 'org_name': '' };
  stateData: Array<any> = [];
  spaTerritories: Array<any> = [];
  territoryStates: any = [];
  hasSearchedOrgName: boolean = false;
  @Output() manualeligibilitycompletionstatus = new EventEmitter<any>();
  @Output() showSelectedStateZipAndSearchSection = new EventEmitter<any>();
  @Output() manualValues = new EventEmitter<any>();
  @Output() stateAndZipPresent = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();
  suggestions = [];

  constructor(private cfetService: CfetService, private router: Router, private http: HttpClient,
    private loaderService: LoaderService, private cdRef: ChangeDetectorRef
  ) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.stateList = [];
    this.stateValueOption = { 'value': 'Select', 'text': 'Select' };
    this.nameValue = new UntypedFormControl('', [Validators.required]);
    this.address1Value = new UntypedFormControl('',{ validators: [Validators.required], updateOn: 'change' });
    this.address2Value = new UntypedFormControl('', [Validators.required]);
    this.cityValue = new UntypedFormControl('', [Validators.required]);
    this.stateValue = new UntypedFormControl('', [Validators.required]);
    this.zipCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(5)], updateOn: 'change' });
    this.dontSeeYourWorkplaceFormGroup = new UntypedFormGroup({
      nameValue: this.nameValue,
      address1Value: this.address1Value,
      address2Value: this.address2Value,
      cityValue: this.cityValue,
      stateValue: this.stateValue,
      zipCode: this.zipCode
    });
    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.spaTerritories = commonListValues['validSPATerritories'];
    this.stateData = commonListValues['validStates'];
    Object.keys(this.spaTerritories).forEach((key) => {
      let val = this.spaTerritories[key];
      this.stateData = this.stateData.concat(val);
      this.territoryStates = this.territoryStates.concat(val);
    });
    this.stateData.sort();
    if (this.stateData && this.stateData.length > 0) {
      this.stateList = this.stateData.map(
        stateValue => {
          return { value: stateValue, text: stateValue.split(':')[1] };
        }
      );
    }
    if (JSON.parse(sessionStorage.getItem("StoreManulValues"))) {
      this.values = JSON.parse(sessionStorage.getItem("StoreManulValues"));
      this.nameValue.setValue(this.values.name);
      this.address1Value.setValue(this.values.Address1);
      this.address2Value.setValue(this.values.Address2);
      this.cityValue.setValue(this.values.City);
      let stateValue = this.values.State.split(':')[0];
      let stateObject = { state: stateValue };
      this.setStateValue(stateObject);
      this.zipCode.setValue(this.values.Zip);
      // Check form validity after populating the values
      this.checkFormValidity();
    }
  }


  onValueChanges() {
    this.dontSeeYourWorkplaceFormGroup.valueChanges.subscribe(val => {
      if (val.nameValue.trim() !== '' && val.nameValue.length > 1 && !val.nameValue.startsWith(' ')
        && val.address1Value.trim() !== '' && val.address1Value.length > 1 && !val.address1Value.startsWith(' ')
        && val.cityValue.trim() !== '' && val.cityValue.length > 1 && !val.cityValue.startsWith(' ')
        && (val.stateValue !== '' && val.stateValue !== 'Select')
        && (val.zipCode !== '' && val.zipCode.replace(/[^0-9\-]/g, '').length > 4)) {
        this.disabledSubmitButton = false;
      } else {
        this.disabledSubmitButton = true;
      }
    });
  }

  searchOrgName(event) {
    this.loaderService.showLoading();
    this.hasSearchedOrgName = true;
    let entityName = '';
    if (event.key === 'Enter') {
      console.log('enter');
      entityName = event.target.value;
    } else if (event.type === 'mousedown') {
      console.log('clicky');
      entityName = (document.getElementById('name') as HTMLInputElement).value
    }
    const requestParam = {
      "agency-name": entityName
    };
    this.cfetService.cfetLivePost(requestParam, CFETILMEndpointsConstant.AI_SEARCH).subscribe((data: any) => {
      this.suggestions = (data && data['result-list'] && data['result-list'].length > 0)
        ? data['result-list'].slice(0, 10)
        : [];
      this.loaderService.hideLoading();
      this.cdRef.detectChanges();
    }, (error: any) => {
      console.error('Error fetching organization profile:', error);
      this.loaderService.hideLoading();
      this.cdRef.detectChanges();
    });
  }

  onSuggestionClick(suggestion) {
    this.nameValue.setValue(suggestion);
  }

  checkName() {
    const regexpName = new RegExp(/^([a-z0-9A-Z_!#^$%*)(+&@'\- ]{2,})$/);
    this.isValidName = regexpName.test(this.nameValue.value);
    this.onValueChanges();
    if (!this.hasSearchedOrgName && this.nameValue.value.trim()) {
      this.searchOrgName({ key: 'Enter', target: { value: this.nameValue.value } });
    }
    this.hasSearchedOrgName = false;
  }

  checkAddress1() {
    this.isValidAddress1 = this.address1Value.value.length > 1 ? false : true;
    this.onValueChanges();
  }
  checkFormValidity() {
    const val = this.dontSeeYourWorkplaceFormGroup.value;
    this.disabledSubmitButton = !(val.nameValue.trim() &&
                                   val.address1Value.trim() &&
                                   val.cityValue.trim() &&
                                   val.stateValue !== 'Select' &&
                                   val.zipCode.replace(/[^0-9]/g, '').length >= 5);
  }

  autoPopulateAPI () {
      if (this.address1Value.value && this.address1Value.value.length >= 2) {
        const addressAPI = CFETILMEndpointsConstant.addresspopulateAPI + '?search=' + this.address1Value.value.replace(' ', '+') + '&auth-id=' + environment.authId + '&max_results=10';
        const addressPopulatexhr = new XMLHttpRequest();
        // address status xhr - new http request
        addressPopulatexhr.open('GET', addressAPI);
        // address status get call
        addressPopulatexhr.send();
        // send the call
        addressPopulatexhr.onreadystatechange = () => {
          if (addressPopulatexhr.response && addressPopulatexhr.readyState === 4 && addressPopulatexhr.status === 200) {
            const addressResponse = JSON.parse(addressPopulatexhr.response);
            if (addressResponse && addressResponse.suggestions && addressResponse.suggestions.length > 0) {
              this.displaySearchResult = true;
              this.addressList = addressResponse.suggestions;
            } else {
              this.noResultFound = true;
              this.displaySearchResult = false;
            }
          }
          else {
            this.displaySearchResult = false;
            this.noResultFound = false;
          }
        }
      } else {
        this.displaySearchResult = false;
        this.noResultFound = false;
      }

        /* let addressResponseurl : any= `${environment.getApiLiveUrl()}${CFETILMEndpointsConstant.addresspopulateAPItest}`;

        this.http.get(addressResponseurl).subscribe(data =>{
          console.log(data);
          let addressResponse : any = data;
          if (addressResponse && addressResponse.suggestions && addressResponse.suggestions.length > 0) {
            this.displaySearchResult = true;
            this.addressList = addressResponse.suggestions;
          } else {
            this.noResultFound = true;
            this.displaySearchResult = false;
          }
        })
      }else {
        this.displaySearchResult = false;
        this.noResultFound = false;
      } */
    }

    onChangeaddress (event, row) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.displaySearchResult = false;
      this.address1Value.setValue(row.street_line);
      this.address2Value.setValue(row.secondary);
      this.cityValue.setValue(row.city);
      this.setStateValue(row);
      this.zipCode.setValue(row.zipcode);
      this.cityError = this.cityValue.value.length > 1 ? false : true;
      this.stateError = this.stateValue.value === 'Select' ? true : false;
      this.zipcodeError = this.zipCode.value.length < 5 ? true : false;

    }
  };

  setStateValue (row) {
    if (this.stateData && row.state) {
      this.stateData.forEach(stateElem => {
        if (stateElem && stateElem.split(':')[0] === row.state) {
          this.stateValueOption = { 'value': stateElem, 'text': stateElem.split(':')[1] };
          this.stateValue.setValue(stateElem);
        }
      });
    }
  }



  checkCity() {
    this.cityError = this.cityValue.value.length > 1 ? false : true;
    this.onValueChanges();
  }

  changeZip() {
    this.zipCode.setValue(this.zipCode.value.replace(/\D/g, ''));
    this.onValueChanges();
    this.checkZip();
  }

  onChangeState(event) {
    this.checkState = '';
    this.stateValue.setValue(event.value);
    this.onValueChanges();
  }

  onClickState(event) {
    if (event.target.ariaExpanded === 'true') {
      this.checkState = 'dropdown-opened';
    } else {
      this.checkState = '';
    }
  }

  checkStateFn () {
    this.stateError = this.stateValue.value === 'Select' ? true : false;
  }

  checkZip() {
    this.zipcodeError = this.zipCode.value.length < 5 ? true : false;
  }

  submit(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
     let orgDetails = {
      name : this.nameValue.value,
      Address1 : this.address1Value.value,
      Address2 : this.address2Value.value,
      City : this.cityValue.value,
      State : this.stateValue.value,
      Zip : this.zipCode.value.replace(/[^0-9\-]/g, '')
      }
      sessionStorage.setItem('StoreManulValues',JSON.stringify(orgDetails));
      // RapidSOS org selection must survive manual address entry - only the workplace address changes here.
      const storedOrgInfo = sessionStorage.getItem('orgInfo');
      if (storedOrgInfo && !JSON.parse(storedOrgInfo)['isRapidSOS']) {
        sessionStorage.removeItem('orgInfo');
      }
      if(this.suggestions.includes(this.nameValue.value)){
        sessionStorage.setItem('agencyNameSource', 'fuzzyAI');
      }
      else {
        sessionStorage.setItem('agencyNameSource', 'userManualEntry');
      }
      sessionStorage.setItem('agencyName', this.nameValue.value);
      console.log("MANUAL FLOW → agencyName set:", this.nameValue.value);
      this.showEnterWorkplaceFormManuallySection = false;
      this.selectedName = this.nameValue.value;
      this.selectedAddress1 = this.address1Value.value;
      this.selectedAddress2 = this.address2Value.value;
      this.selectedCity = this.cityValue.value;
      this.selectedState = this.stateValue.value;
      this.selectedZip = this.zipCode.value.replace(/[^0-9\-]/g, '');
      this.manualValues.emit(true);
      this.checkstateAndZip['org_name'] = this.nameValue.value;
      this.checkstateAndZip['address'] = this.address1Value.value;
      this.checkstateAndZip['city'] = this.cityValue.value;
      this.checkstateAndZip['state'] = this.stateValue.value;
      this.checkstateAndZip['zipcode'] = this.zipCode.value.replace(/[^0-9\-]/g, '');
      this.stateAndZipPresent.emit(this.checkstateAndZip);
      let isSpaTerriroryState = this.territoryStates.includes(this.selectedState);
      const workPlaceInfo = {
        completionStatus: true,
        selectedName: this.selectedName,
        selectedAddress: this.selectedAddress2 ? this.selectedAddress1 + ',' + this.selectedAddress2 : this.selectedAddress1,
        selectedCity: this.selectedCity,
        selectedStateInWorkplace: this.selectedState,
        selectedZipInWorkplace: this.selectedZip.replace(/[^0-9\-]/g, ''),
        isSpaTerriroryState: isSpaTerriroryState
      };
      this.manualeligibilitycompletionstatus.emit(workPlaceInfo);
    }
  }


  // for capturing the browser back button event
/*   @HostListener('window: popstate', ['$event'])
  onPopState (event: Event): void {
    event.preventDefault();
    if (this.showPersonalInfoSection) {
      this.goBack({ key: 'Enter' });
    } else {
      this.location.back();
    }
    window.scrollTo(0, 0);
  } */

  @HostListener('keyup', ['$event']) onKeyUp (e) {
    if (e.key == "Tab" && e.keyCode == 9) {
      this.fieldTabbed = true;
    } else {
      this.fieldTabbed = false;
    }
  }
  @HostListener('document:click', ['$event']) ondivBlur (event) {
    if (event && event.target && (event.target.id !== 'address1' && event.target.id !== 'search-result'
      && event.target.id !== 'address-field-list' && event.target.id !== 'workplace-link' && event.target.id !== 'manually-enter')) {
      this.displaySearchResult = false;
      this.noResultFound = false;
    }
  }

  @HostListener('keyup', ['$event']) ondivFocus (event) {
    if (event && event.target && event.keyCode === 9 && (event.target.id !== 'address1' && event.target.id !== 'search-result'
      && event.target.id !== 'address-field-list' && event.target.id !== 'workplace-link' && event.target.id !== 'manually-enter' && event.target.id !== 'address-field-details' && event.target.id !== 'gray-text')) {
      this.displaySearchResult = false;
      this.noResultFound = false;
    }
  }

  @HostListener('document:click',['$event'])
    documentClick(event: Event): void {
    this.displaySearchResult = false;
    this.noResultFound = false;
  }



  keyDownHandler(event: any) {
    if (event.which === 32 && event.target.selectionStart === 0) {
      event.preventDefault();
    }
  }
  pasteHandler(event: any) {
    let value = event.clipboardData.getData('text/plain');
    value = value.trim();
    event.currentTarget.value = value;
    event.preventDefault();
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

  editWorkplace(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSelectedStateZipAndSearchSection.emit(true);
      this.showEligibilityCompletion = false;
    }
  }
}
